import { ChangeDetectionStrategy, Component } from '@angular/core';
import { COMPANY_ASYNC_EXPORT_SERVICE_CONFIG, CompanyAsyncExportModule } from '../../../../shared/components';
import { CompanySFAsyncExportService } from './company-sf-async-export.service';

@Component({
    template: `
		<app-company-async-export></app-company-async-export>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [{
            provide: COMPANY_ASYNC_EXPORT_SERVICE_CONFIG,
            useClass: CompanySFAsyncExportService,
        }],
    imports: [
        CompanyAsyncExportModule
    ]
})
export class CompanySfAsyncExportComponent {}
